/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PatchNotificationReqBodyDto
 */
export interface PatchNotificationReqBodyDto {
    /**
     * 업데이트할 알림 상태
     * @type {string}
     * @memberof PatchNotificationReqBodyDto
     */
    'sentNotificationStatusType': PatchNotificationReqBodyDtoSentNotificationStatusTypeEnum;
    /**
     * 알림 uuid 배열
     * @type {Array<string>}
     * @memberof PatchNotificationReqBodyDto
     */
    'targetIds': Array<string>;
}

export const PatchNotificationReqBodyDtoSentNotificationStatusTypeEnum = {
    Read: 'read',
    Click: 'click'
} as const;

export type PatchNotificationReqBodyDtoSentNotificationStatusTypeEnum = typeof PatchNotificationReqBodyDtoSentNotificationStatusTypeEnum[keyof typeof PatchNotificationReqBodyDtoSentNotificationStatusTypeEnum];


